const merge = require('lodash.merge');

const {get, post, patch, del} = require('./agent');

module.exports = (global_options) => {
  return {
    create: (data, local_options) => {
      const options = merge({}, global_options, local_options);
      return post('/syndicates', data, options);
    },
    get: (id, local_options) => {
      const options = merge({}, global_options, local_options);
      return get(`/syndicates/${id}`, options);
    },
  }
}



// WEBPACK FOOTER //
// ../covert/syndicates.js